import { getLoggedInEmployee } from "../services/getLoggedInEmployee";

export const getNewLoggedInEmployeeFunction = async (setLoggedInEmployee) => {
  const currentEmployee = await getLoggedInEmployee();
  if (currentEmployee.success) {
    setLoggedInEmployee(currentEmployee.data.employeeResponse);
    console.log(currentEmployee);
  }
};
